import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import FormContext from "formContext";
import SelectField from "@FormElements/SelectField";
import {useSpecialismsList} from "i18nHelper";

function SpecialismSelectFields({intl, settings, ...rest}) {
  const {state, name} = settings || {};
  const {onChange} = rest;
  const {additionalData: {specialisms}, currentStep, setFormData} = useContext(FormContext);

  const SpecialismField = () => {
    const specialisms = useSpecialismsList(intl.locale);

    const specialismOptions = [];
    specialismOptions.push({ value: "", label: intl.formatMessage({id: 'SelectField.EmptyOption.Label'}) });
    for (let specialismId in specialisms) {
      specialismOptions.push({
        value: specialismId,
        label: specialisms[specialismId],
      });
    }

    settings.options = specialismOptions;
    return (
      <SelectField
        settings={settings}
        {...rest}
        onChange={handleSpecialismChange}
      />
    )
  };

  const handleSpecialismChange = event => {
    if (settings && settings.subspecialism && settings.subspecialism.name) {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        const subSpecialismName = settings.subspecialism.name;
        prev[currentStep][subSpecialismName] = '';
        prev[currentStep]['specialism_id'] = '';
        prev[currentStep]['sub_specialism_id'] = '';
        return {
          ...prev
        }
      });
    }
    onChange(event);
  };

  return (
    <>
      <SpecialismField />
    </>
  )
}

export default injectIntl(SpecialismSelectFields);
